/**
 * Common style definitions for consistent UI elements across the application
 */

/**
 * Standard separator line style used across the application
 * Matches the style used for top bar and sidebar separators
 */
export const separatorLineClass =
  "border-b border-white/20 dark:border-white/20";

/**
 * Section separator line style - more visible for main section headings
 */
export const sectionSeparatorLineClass = "border-b-2 border-[#131314]";

/**
 * SPACING STANDARDS
 */

/**
 * Standard section container spacing - use for all major page sections
 */
export const sectionContainerClass = "p-4 sm:p-6 mb-4 sm:mb-6";

/**
 * Standard spacing between section header and separator line
 */
export const sectionHeaderSpacing = "mb-3";

/**
 * Standard spacing between separator line and content
 */
export const sectionSeparatorSpacing = "mb-6";

/**
 * Standard spacing between content groups within a section
 */
export const contentGroupSpacing = "mb-6";

/**
 * Standard padding for card-like components (large cards like stats, analysts)
 */
export const cardPadding = "p-4 sm:p-6";

/**
 * Compact padding for smaller horizontal cards (news, peers)
 */
export const compactCardPadding = "p-3 sm:p-4";

/**
 * Standard gap between cards in grids
 */
export const cardGridGap = "gap-4";

/**
 * TYPOGRAPHY STANDARDS
 */

/**
 * Main section heading (h2) - for primary section titles
 */
export const sectionHeadingClass =
  "font-bold text-2xl sm:text-3xl md:text-4xl text-white/90";

/**
 * Subsection heading (h3) - for secondary headings within sections
 */
export const subsectionHeadingClass =
  "font-normal text-lg sm:text-xl text-white/90";

/**
 * Body text - standard size for content
 */
export const bodyTextClass = "text-sm sm:text-base";
